import "@shared/ui.primitives/style.css";
import "@shared/ui.components/style.css";
import { clsx } from "clsx";
import React from "react";

import * as styles from "./PageContainers.css";

type PageProps = {
  children: React.ReactNode;
};

export const ProductContainer: React.FC<PageProps> = ({ children }) => {
  return <div className={styles.productContainer}>{children}</div>;
};

export const ScrollContainer: React.FC<PageProps> = ({ children }) => {
  return <div className={styles.scrollContainer}>{children}</div>;
};

export const CoreProductInfoContainer: React.FC<PageProps> = ({ children }) => {
  return <div className={styles.coreProductInfoContainer}>{children}</div>;
};

export const CoreProductWrapper: React.FC<PageProps> = ({ children }) => {
  return <div className={styles.coreProductWrapper}>{children}</div>;
};

export const PricingActionsMobileWrapper: React.FC<PageProps> = ({
  children
}) => {
  return <div className={styles.pricingActionsMobileWrapper}>{children}</div>;
};

export const MobileProductAttributesContainer: React.FC<PageProps> = ({
  children
}) => {
  return (
    <div className={styles.mobileProductAttributesContainer}>{children}</div>
  );
};

export const MobileTopBlockContainer: React.FC<PageProps> = ({ children }) => {
  return <div className={styles.mobileTopBlockContainer}>{children}</div>;
};

export const MobileDescriptionContainer: React.FC<PageProps> = ({
  children
}) => {
  return <div className={styles.mobileDescriptionContainer}>{children}</div>;
};

export const RelatedVariantsContainer: React.FC<PageProps> = ({ children }) => {
  return <div className={styles.relatedVariantsContainer}>{children}</div>;
};

export const OOSContainer: React.FC<PageProps> = ({ children }) => {
  return <div className={styles.oosContainer}>{children}</div>;
};

export const DesktopRelatedVariantsContainer: React.FC<PageProps> = ({
  children
}) => {
  return (
    <div
      className={clsx(styles.relatedVariantsContainer, styles.hideForMobile)}
    >
      {children}
    </div>
  );
};

export const FindOutMoreAnchorContainer: React.FC = () => {
  return (
    <div
      id="find-out-more-anchor"
      className={styles.findOutMoreAnchorContainer}
    ></div>
  );
};
